(function () {
	'use strict';
	angular
		.module('jcsfApp')
		.controller('jccenterController', jccenterController);

	jccenterController.$inject = [
		'$controller',
		'$rootScope',
		'$scope',
		'events',
		'authService',
	];

	function jccenterController(
		$controller,
		$rootScope,
		$scope,
		events,
		authService
	) {
		$controller('baseController', { $scope: $scope });

		var vm = this;
		vm.center = {};
		vm.rsas = [];

		authService.fillAuthData();

		activate();

		vm.cancel = function () {
			$scope.publish(events.message._GET_JCCENTER_, [vm.center.CenterId]);
		};

		vm.save = function () {
			if (vm.center.CenterId > 0) {
				vm.center.LastModifiedBy = authService.authentication.userName;
			} else {
				vm.Creator = authService.authentication.userName;
			}
			$scope.publish(events.message._SAVE_JCCENTER_, [vm.center]);
		};

		function activate() {
			if (
				authService.authentication.userName == null ||
				!authService.authentication.isAuth
			) {
				$scope.$state.go('login');
			}
			if ($rootScope.$stateParams.id == null) {
				$scope.$state.go('home');
			}

			$scope.subscribe(
				events.message._GET_JCCENTER_COMPLETE_,
				function (results) {
					vm.center = results;
				}
			);
			$scope.subscribe(
				events.message._SAVE_JCCENTER_COMPLETE_,
				function (results) {
					vm.center = results;
				}
			);
			$scope.subscribe(
				events.message._GET_RSA_LIST_COMPLETE_,
				function (results) {
					vm.rsas = results;
				}
			);

			$scope.publish(events.message._GET_JCCENTER_, [
				$rootScope.$stateParams.id,
			]);
			$scope.publish(events.message._GET_RSA_LIST_, []);
		}
	}
})();
